import Marquee from "react-fast-marquee";

const WORDS = [
  "Paro",
  "Thimphu",
  "Punakha",
  "Bumthang",
  "Haa Valley",
  "Taktsang",
  "Dochula",
  "Phobjikha",
  "Wangdue",
  "Trongsa",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="relative border-y border-foreground/15 bg-background overflow-hidden py-6 md:py-8"
    >
      <Marquee gradient={false} speed={30} pauseOnHover>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={`${w}-${i < WORDS.length ? "a" : "b"}`} className="marquee-item">
            <span className="font-serif italic text-5xl md:text-7xl font-light tracking-tight">
              {w}
            </span>
            <span
              className="w-2.5 h-2.5 rotate-45 bg-primary shrink-0"
              aria-hidden
            />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
